var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
const apiUrl = process.env.PORTAL_URL || "";
export function getConfig() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/doacao-sangue/items/Configuracoes?fields=*.*`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data[0];
    });
}
export function getDoador(cpf) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(
        // `${apiUrl}/api/doacao-sangue-doador?fields=*.*&filter[cpf][_eq]=${cpf}`
        `${apiUrl}/api/doacao-sangue/items/doador?fields=*.*&filter[cpf][_eq]=${cpf}`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data[0];
    });
}
export function getNews() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/doacao-sangue/items/posts?limit=3`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getPages() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/doacao-sangue/items/Paginas`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getStock() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/doacao-sangue/items/Estoque`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data[0];
    });
}
export function getSugestaoAgendamento(token, nascimento, cep) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.post(`${apiUrl}/api/agendamento/sugestao-agendamento`, {
            dataNascimento: nascimento,
            servico: "a90c7dc1-fa4f-48b6-93ca-6b1d4307474b",
            cep: cep,
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export function enviarAgendamento(token, usuario, data, hora, unidade) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.post(`${apiUrl}/api/agendamento/reservar`, {
            usuario: usuario,
            servico: "a90c7dc1-fa4f-48b6-93ca-6b1d4307474b",
            data: data,
            hora: hora,
            unidade: unidade,
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export function obterAgendamentoAnterior(token, servicoId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/agendamento/meus-agendamentos?servico=${servicoId}&ativo=true`, { headers: { Authorization: `Bearer ${token}` } });
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
// export async function getBanners(): Promise<IConfig> {
//   const banners = await axios.get(
//     `https://cms.demo.xvia.com.br/items/Configuracoes_files`
//     // `${apiUrl}/api/doacao-sangue/items/Configuracoes_files`
//   );
// return banners?.data?.data?.map((banner: IBanner) => {
//   return {
//     img: `https://cms.demo.xvia.com.br/assets/${banner.directus_files_id}`,
//   };
//   //return `${apiUrl}/api/doacao-sangue/items/Configuracoes`
// });
// }
// export const getSugestaoAgendamento = (
//     api: AxiosInstance,
//     body: { dataNascimento: null | string; servico: string; cep: null | string }
// ) => {
//   return api.post("/sugestao-agendamento", body);
// };
